import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import { setupProductModels } from './product-model';

const refreshActiveModelViewer = (swiper) => {
  const activeSlide = swiper.slides?.[swiper.activeIndex];
  const modelViewer = activeSlide?.querySelector('model-viewer');
  if (!modelViewer) return;

  setupProductModels();
  modelViewer.dispatchEvent(new Event('resize'));
};

const initLightboxSwiper = (gallery) => {
  const lightboxSwiperEl = gallery.querySelector('[data-product-gallery-lightbox-swiper]');
  if (!lightboxSwiperEl || lightboxSwiperEl.swiper) return;

  const prevEl = gallery.querySelector('[data-product-gallery-lightbox-prev]');
  const nextEl = gallery.querySelector('[data-product-gallery-lightbox-next]');
  const paginationEl = gallery.querySelector('[data-product-gallery-lightbox-pagination]');

  const lightboxConfig = {
    modules: [Navigation, Pagination],
    slidesPerView: 1,
    initialSlide: 0,
  };

  if (prevEl && nextEl) {
    lightboxConfig.navigation = { prevEl, nextEl };
  }

  if (paginationEl) {
    lightboxConfig.pagination = {
      el: paginationEl,
      type: 'fraction',
    };
  }

  const lightboxSwiper = new Swiper(lightboxSwiperEl, lightboxConfig);

  lightboxSwiper.on('slideChange', () => refreshActiveModelViewer(lightboxSwiper));
  refreshActiveModelViewer(lightboxSwiper);

  lightboxSwiperEl.classList.add('swiper--active');
};

const initProductGalleryLightbox = () => {
  const galleries = document.querySelectorAll('[data-product-gallery]');
  if (!galleries.length) return;
  const overflowHiddenClass = 'overflow-hidden';

  galleries.forEach((gallery) => {
    const dialog = gallery.querySelector('[data-product-gallery-dialog]');
    const closeButton = gallery.querySelector('[data-product-gallery-close]');
    const lightboxSwiperEl = gallery.querySelector('[data-product-gallery-lightbox-swiper]');

    if (!dialog || !lightboxSwiperEl) return;

    initLightboxSwiper(gallery);

    const openLightbox = (index) => {
      if (!dialog.open) {
        dialog.showModal();
      }
      document.body.classList.add(overflowHiddenClass);

      const swiper = lightboxSwiperEl.swiper;
      if (swiper) {
        swiper.slideTo(index, 0);
        // model-viewer needs a layout pass after the dialog becomes visible
        requestAnimationFrame(() => {
          refreshActiveModelViewer(swiper);
          requestAnimationFrame(() => refreshActiveModelViewer(swiper));
        });
      }
    };

    const closeLightbox = () => {
      if (dialog.open) {
        dialog.close();
      }
      document.body.classList.remove(overflowHiddenClass);
    };

    gallery.querySelectorAll('[data-product-gallery-open]').forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        const index = Number(trigger.dataset.mediaIndex || 0);
        openLightbox(index);
      });
    });

    closeButton?.addEventListener('click', closeLightbox);

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) {
        closeLightbox();
      }
    });

    dialog.addEventListener('close', () => {
      document.body.classList.remove(overflowHiddenClass);
    });
  });
};

export default initProductGalleryLightbox;
